const featuredItems = [
  {
    name: 'Кроссовки Premium',
    desc: 'Тренд сезона',
    img: 'https://readdy.ai/api/search-image?query=Premium%20white%20designer%20sneakers%20on%20clean%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20fashion%20style%2C%20elegant%20presentation%20with%20gentle%20shadows&width=800&height=800&seq=feat-sneakers&orientation=squarish',
  },
  {
    name: 'Худи Oversize',
    desc: 'Бестселлер',
    img: 'https://readdy.ai/api/search-image?query=Oversized%20warm%20beige%20hoodie%20sweater%20on%20clean%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20fashion%20style%2C%20elegant%20presentation&width=800&height=800&seq=feat-hoodie&orientation=squarish',
  },
  {
    name: 'Сумка кожаная',
    desc: 'Новинка',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20leather%20tote%20bag%20on%20clean%20cream%20background%2C%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20fashion%20style%2C%20refined%20presentation&width=800&height=800&seq=feat-bag&orientation=squarish',
  },
  {
    name: 'Аксессуары Premium',
    desc: 'Хит продаж',
    img: 'https://readdy.ai/api/search-image?query=Minimalist%20watch%20and%20leather%20bracelet%20on%20clean%20cream%20background%2C%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20fashion%20style%2C%20elegant%20presentation&width=800&height=800&seq=feat-accessory&orientation=squarish',
  },
];

export default function FeaturedProducts() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-foreground-950 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Dark%20minimalist%20fashion%20product%20flatlay%20with%20accessories%20and%20clothing%20items%20on%20dark%20surface%2C%20subtle%20texture%2C%20low%20key%20lighting%2C%20editorial%20photography%20with%20moody%20atmosphere%2C%20rich%20dark%20tones&width=1600&height=1200&seq=feat-dark-bg&orientation=landscape)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div className="lg:w-1/3">
            <span className="inline-block px-5 py-2 border border-foreground-600 rounded-full text-xs font-medium text-background-50 font-body tracking-wide uppercase whitespace-nowrap">
              Новинки
            </span>
          </div>
          <div className="lg:w-2/3">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-background-50 leading-tight">
              Популярные товары
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredItems.map((item) => (
            <div key={item.name} className="group cursor-pointer">
              <div className="bg-secondary-50/10 rounded-2xl overflow-hidden p-3">
                <div className="w-full aspect-square rounded-xl overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.name}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="mt-4 px-1">
                <h3 className="font-body text-base font-semibold text-background-50 whitespace-nowrap">{item.name}</h3>
                <p className="mt-1 text-sm text-foreground-400 font-body whitespace-nowrap">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}